import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function DisabledAdIntegrationWarning() {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.adIntegrationWarning"
    })
  });
}
export default DisabledAdIntegrationWarning;